import mergeDeep from "../../util/mergeDeep.js";
import redirector from "../../util/redirector.js";
import { getStore } from "../../store/configureStore";

export default class BovenLokaliteitPerDossierPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	receiveProps(nextProps) {
		if (this.context.props.bovenLokaliteitPerDossier !== nextProps.bovenLokaliteitPerDossier) {
			if (nextProps.bovenLokaliteitPerDossier.tabTitel) {
				let infrastructuurId = nextProps.infrastructuren.length > 0 ? nextProps.infrastructuren[0].id : null;
				this.context.props.loadLayout(nextProps.bovenLokaliteitPerDossier.naam, nextProps.bovenLokaliteitPerDossier.tabTitel, nextProps.dossierId, nextProps.bovenLokaliteitPerDossier.typeDossier, infrastructuurId, (nextProps.bovenLokaliteitPerDossier.redenVanStatus != "121450000" && nextProps.bovenLokaliteitPerDossier.redenVanStatus !== 121450000));
			}
			this.context.setState({
				bovenLokaliteitPerDossier: mergeDeep({}, nextProps.bovenLokaliteitPerDossier)
			});
		}

		const hasCoordinates = nextProps.bovenLokaliteitPerDossier ? (nextProps.bovenLokaliteitPerDossier.breedtegraad && nextProps.bovenLokaliteitPerDossier.lengtegraad) : false;
		if (hasCoordinates && (nextProps.infrastructuren && nextProps.infrastructuren.length > 0)) {
			redirector.goTo("/bovenlokaliteit/" + nextProps.bovenLokaliteitPerDossier.dossierId + "/infrastructuur/" + nextProps.infrastructuren[0].id);
		}
	}

	init() {
		const dossierId = this.context.props.dossierId;
		const infrastructuurId = this.context.props.infrastructuren[0] !== undefined ? this.context.props.infrastructuren[0].id : null;

		if (dossierId) {
			this.context.props.loadInfrastructurenByDossierId(dossierId);
			this.context.props.loadBovenLokaliteitPerDossier(dossierId);
		}
	}
}